export default __webpack_public_path__ + "static/media/Copy of backgroudn-check.fda3a752.jpg";